import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UserStorageService } from '../../../services/user-storage-service/user-storage.service';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';
import { DevicesDevicesService } from 'src/app/services/devices-services/devices-devices-services/devices-devices.service';
import { Subscription } from 'rxjs';
import { CenterLite } from 'src/app/models/center-model/center-lite.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { tap } from 'rxjs/internal/operators/tap';
import { catchError } from 'rxjs/operators';
import {LicensesService} from "../../../services/licenses-service/licenses.service";
import {License} from "../../../models/licenses-model/license.model";

@Component({
  selector: 'app-devices-register-device-dialog',
  templateUrl: './devices-register-device-dialog.component.html',
  styleUrls: ['./devices-register-device-dialog.component.scss']
})
export class DevicesRegisterDeviceDialogComponent implements OnInit, OnDestroy {

  centers: CenterLite[];
  licenses: License[];
  error: string;
  basicDataForm = new FormGroup({
    token: new FormControl(null, Validators.required),
    selectedCenter: new FormControl(null, Validators.required),
    name: new FormControl(null),
    selectedLicense: new FormControl(null, Validators.required),
  });
  addNewDeviceSubscription: Subscription;
  getLicensesSubscription: Subscription;

  constructor(public dialogRef: MatDialogRef<DevicesRegisterDeviceDialogComponent>,
              public devicesService: DevicesDevicesService,
              private userStorageService: UserStorageService,
              private licensesService: LicensesService,
              private snackbarService: SnackBarService) {
              }

  ngOnInit() {
    this.getLicenses();
    this.centers = this.userStorageService.getCenterList();
    if (this.centers && this.centers.length === 1) {
      this.basicDataForm.patchValue({
        selectedCenter: this.centers[0]
      });
    }
  }

  public getLicenses() {
    this.getLicensesSubscription = this.licensesService.getLicenses().subscribe(
      (res) => {
        this.licenses = res;
        this.basicDataForm.patchValue({
          selectedLicense: this.licenses[0]
        });
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public registerDevice() {
    this.error = '';
    const validation = this.validateForm();
    if (validation === true) {
      this.addNewDeviceSubscription = this.devicesService.addDeviceWithLicense(
        this.basicDataForm.get('token').value.toUpperCase(),
        this.basicDataForm.get('selectedCenter').value.InternalId,
        this.basicDataForm.get('name').value,
        this.basicDataForm.get('selectedLicense').value.InternalId)
      .pipe(
        tap(o => this.dialogRef.close()),
        tap(o => this.snackbarService.open('devices-page.snackbar messages.link device success', 'success')),
        tap(o => this.devicesService.refreshDevices()),
        catchError(err => this.error += err['error']['message'])
      ).subscribe();
    } else {
      this.error += validation;
    }
  }

  public validateForm() {
    if (!this.basicDataForm.get('token').valid) {
      return 'devices-page.snackbar messages.token iot error';
    } if (!this.basicDataForm.get('selectedCenter').valid) {
      return 'devices-page.snackbar messages.selected center iot error';
    } if (!this.basicDataForm.get('selectedLicense').valid) {
      return 'devices-page.snackbar messages.selected license iot error';
    } else {
      return true;
    }
  }

  public setPreselected(op1, op2) {
    if (op1 && op2) {
      return op1.InternalId === op2.InternalId;
    }
  }

  ngOnDestroy() {
    if (this.addNewDeviceSubscription) { this.addNewDeviceSubscription.unsubscribe(); }
    if (this.getLicensesSubscription) { this.getLicensesSubscription.unsubscribe(); }
  }

}
